import { render, staticRenderFns } from "./ReferenceUnitList.vue?vue&type=template&id=45a860ca"
import script from "./ReferenceUnitList.vue?vue&type=script&lang=js"
export * from "./ReferenceUnitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports